
import * as d3 from 'd3'
export default {
  methods: {

    draw_Contents() {
      let viewbox = this.scroll.viewbox
      
      this.canvasContents = this.svg
      .append('g')
      .attr('transform', `translate(${this.table.x}, ${this.table.y})`)
      .attr('font-family', 'roboto')

      this.canvasContents
      .append('defs')
      .append('clipPath')
      .attr('id', `CLIP_AREA_${this.localId}`)
      .append('rect')
      .attr('x', viewbox.x).attr('y', viewbox.y)
      .attr('width', viewbox.width).attr('height', viewbox.height)

    
      // clippedGroup // Stroke for temporary
      // .append('rect')
      // .attr('x', viewbox.x).attr('y', viewbox.y).attr('stroke', '#757575').attr('stroke-width', 0.5)
      // .attr('width', viewbox.width).attr('height', viewbox.height).attr('fill', 'none')
      
      this.draw_List()
    },


    draw_List() {

      let clippedGroup = this.canvasContents
      .append('g')
      .attr('transform', `translate(5, 0)`)
      .attr('clip-path', `url(#CLIP_AREA_${this.localId})`)

      let dataGroup = clippedGroup
      .append('g')
      .attr('id', `CONTENTS_${this.localId}`)
      .attr('transform', `translate(0, ${this.scroll.viewbox.y})`)
      
      let y_ = 11
      this.rawData.filter(f=> f.CAT == this.current.itr).forEach((d,i)=> {

        let row = dataGroup
        .append('g')
        .attr('transform', `translate(0, ${y_})`)
        .attr('cursor', 'pointer')
        .call(this.call_List, i)

        row
        .append('rect')
        .attr('id', `ROW_${i}_${this.localId}`)
        .attr('x', 0).attr('y', -9)
        .attr('width', this.table.width).attr('height', 17)
        .attr('fill', '#B4E3FA').attr('opacity', 0)

        row
        .append('text')
        .attr('transform', `translate(${15}, ${10*0.35})`)
        .attr('font-size', 10).attr('fill', '#606060')
        .attr('text-anchor', 'middle')
        .text(i+1)

        this.columns.forEach((col,c)=> {

          if(col.code == 'PRO') {

            let proLen = (d[col.code]/100) * 120
            let prog = row
            .append('g')
            .attr('transform', `translate(${col.tx-5}, 0)`)

            prog
            .append('rect')
            .attr('x', 0).attr('y', -5)
            .attr('width', 120).attr('height', 10)
            .attr('fill', '#F4F5F5')

            prog
            .append('rect')
            .attr('x', 0).attr('y', -5)
            .attr('width', proLen).attr('height', 10)
            .attr('fill', '#83D2F5')

            prog
            .append('text')
            .attr('x', d[col.code] < 75 ? proLen + 1 : proLen - 1)
            .attr('y', 9.5*0.35).attr('font-size', 9.5)
            .attr('fill', '#606060')
            .attr('text-anchor', d[col.code] < 75 ? 'start' : 'end')
            .text(d[col.code] + '%')

          } else {
            row
            .append('text')
            .attr('transform', `translate(${col.tx}, ${10*0.35})`)
            .attr('font-size', 10)
            .attr('fill', d[col.code] == 0 ? '#E0E0DF' : '#606060')
            .attr('text-anchor', col.align)
            .text(d[col.code])
            .call(this.event_Link, d, col, col.tx)
          }
        })
        y_ += 20
      })

      this.scroll.content.height = y_ - 10
      this.set_ScrollValues()
    }
  }
}